import script from "./TODO_CHANGE.vue?vue&type=script&setup=true&lang=ts"
export * from "./TODO_CHANGE.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__